import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './WithdrawAmount.css';
import axios from 'axios';

function WithdrawAmount() {
  const navigate = useNavigate();
  const location = useLocation();
  const { method, details } = location.state || {};
  const [amount, setAmount] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const userData = JSON.parse(localStorage.getItem('user') || '{}');
  const userId = userData.userId || userData._id;

  const handleSubmit = () => {
    if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
      alert('Please enter a valid amount.');
      return;
    }
    setShowConfirmation(true);
  };

  const handleConfirmWithdraw = async () => {
    // Create transaction details
    const transactionDetails = {
      userId,
      transactionId: Math.random().toString(36).substr(2, 9),
      timestamp: new Date().toISOString(),
      amount: parseFloat(amount),
      method: method,
      status: 'Processing',
      details: method === 'upi' ? 
        { upiId: details.upiId } : 
        {
          accountHolder: details.cardHolder,
          accountNumber: details.cardNumber.replace(/\s+/g, ''), // Remove all spaces
          ifscCode: details.ifscCode
        }
    };

    try {
      setLoading(true);
      // Send withdrawal request to backend
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/withdrawals/process`, transactionDetails);
      
      if (response.data.success) {
        // Show success message
        alert(`Withdrawal request processed successfully!\nTransaction ID: ${response.data.transaction.transactionId}`);
        
        // Navigate back to wallet
        navigate('/wallet');
      } else {
        alert('Withdrawal failed: ' + response.data.message);
        setShowConfirmation(false);
      }
    } catch (error) {
      console.error('Error processing withdrawal:', error);
      let errorMessage = 'Withdrawal request failed. Please try again later.';
      
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage += `\nError: ${error.response.data.message}`;
      } else if (error.message) {
        errorMessage += `\nError: ${error.message}`;
      }
      
      alert(errorMessage);
      setShowConfirmation(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="withdraw-amount-container">
      <div className="withdraw-amount-header">
        <button className="back-button" onClick={() => navigate('/withdraw')}>←  </button>
        <h2>Enter Withdrawal Amount</h2>
      </div>

      {method === 'card' && (
        <div className="selected-account-card">
          <div className="card-front saved">
            <div className="card-type">Selected Account</div>
            <div className="card-number">
              {details.cardNumber.replace(/\d(?=\d{4})/g, "•")}
            </div>
            <div className="card-info">
              <div className="card-holder">
                <span>Account Holder</span>
                <div>{details.cardHolder}</div>
              </div>
              <div className="ifsc-code">
                <span>IFSC Code</span>
                <div>{details.ifscCode}</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {method === 'upi' && (
        <div className="selected-upi-details">
          <h3>UPI Details</h3>
          <p>Withdrawing to: {details.upiId}</p>
        </div>
      )}

      <div className="amount-input-section">
        <label htmlFor="amount">Enter Amount to Withdraw</label>
        <div className="amount-input-wrapper">
          <span className="currency-symbol">₹</span>
          <input
            type="number"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            autoFocus
          />
        </div>
      </div>

      <button 
        className="proceed-button" 
        onClick={handleSubmit}
        disabled={loading || !amount}
      >
        Proceed with Withdrawal
      </button>

      {showConfirmation && (
        <div className="confirmation-overlay">
          <div className="confirmation-popup">
            <h3>Confirm Withdrawal</h3>
            <div className="confirmation-details">
              <div className="detail-row">
                <span>Amount:</span>
                <strong>₹{parseFloat(amount).toFixed(2)}</strong>
              </div>
              
              {method === 'card' ? (
                <>
                  <div className="detail-row">
                    <span>Account Holder:</span>
                    <strong>{details.cardHolder}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Account Number:</span>
                    <strong>•••• {details.cardNumber.slice(-4)}</strong>
                  </div>
                  <div className="detail-row">
                    <span>IFSC Code:</span>
                    <strong>{details.ifscCode}</strong>
                  </div>
                </>
              ) : (
                <div className="detail-row">
                  <span>UPI ID:</span>
                  <strong>{details.upiId}</strong>
                </div>
              )}
              
              <div className="confirmation-warning">
                Please verify all details before confirming.
              </div>
            </div>
            
            <div className="confirmation-buttons">
              <button 
                className="cancel-button"
                onClick={() => setShowConfirmation(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                className="confirm-button"
                onClick={handleConfirmWithdraw}
                disabled={loading}
              >
                {loading ? 'Processing...' : 'Confirm Withdrawal'}
              </button>
            </div>
          </div>
        </div>
      )}

      {loading && !showConfirmation && (
        <div className="loading-indicator">
          <div className="loader"></div>
          <p>Processing withdrawal request...</p>
        </div>
      )}
    </div>
  );
}

export default WithdrawAmount;